import WGLogic from './WQDauto';
import Base from '../Base/index';
import islandConst from '../const';
import { isNumber } from '../utils';
import {tzAudio} from "../common";

/*
* 围棋人机下棋主逻辑，系统默认黑先下子
*/
export default class ManMachine extends Base {
  constructor(props) {
    super({
      ...props,
      type: 0, // 画所有棋子
      lastChessShow: true, // 不显示
      chessClick: (sprite) => { // 棋子点击事件
        this.chessEvent(sprite);
      },
      complete: () => {
        // 初始化人机
        this.initLogic();
      },
    });
    // 人机常用对象
    this.Et = {
      nowPoint: {}, // 当前落子的点
      userColor: islandConst.BLACK,
      btColor: islandConst.WHITE,
    };

    // 游戏是否结束
    this.gameEnd = false;
  }

  // 初始化人机
  initLogic = () => {
    const { sz, level, stones } = this.options;
    // 人机对象
    this.WGLogic = new WGLogic(sz, this.onKillStone);
    // 设置机器人级别和吃对方多少颗子后为赢,结果响应函数
    this.WGLogic.setRobotMode(level, stones, this.onResult);
  };

  // 落子事件
  chessEvent = (sprite) => {
    if (this.gameEnd) {
      return false;
    }
    // 机器正在考虑，请等待
    if (this.noCanChess) {
      this.options.onError({
        code: 0,
        message: '机器正在考虑,请等待一秒钟~~~',
      });
      return false;
    }
    if (sprite.alpha === 1) {
      this.options.onError({
        code: -2,
        message: '当前处已有棋子',
      });
      return false;
    }
    // 如果有当前点，取消此点
    this.Et.nowPoint = { ...sprite.point };
    // 用户落子确认
    this.options.userChess(this.Et.nowPoint);
    // 第一步默认黑棋
    this.downChess(this.Et.nowPoint, this.Et.userColor, 0.6);
  };


  // 用户确认
  submit = (point) => {
    const nowPoint = point || this.Et.nowPoint;
    if (!isNumber(nowPoint.x)) {
      this.options.onError({
        code: -5,
        message: '请先落子',
      });
      return false;
    }
    // 清空当前的点
    this.Et.nowPoint = {};
    /*
    * 返回0代表落子成功(错误码:-1,pt在棋盘外, -2,pt处已有棋子,-3,打劫，要隔一步才能落子,-4,不允许自杀)
     */
    const status = this.WGLogic.play(nowPoint);
    // 用户确认落子颜色为1
    this.static.chessAudio.play();
    this.downChess(nowPoint, this.Et.userColor);
    switch (status) {
    case 0:
      // 自动下一步
      this.autoPlay();
      break;
    case -1:
      this.options.onError({
        code: -1,
        message: '当前点击在棋盘外',
      });
      break;
    case -2:
      this.downChess(nowPoint, islandConst.EMPTY);
      this.options.onError({
        code: -2,
        message: '当前处已有棋子',
      });
      break;
    case -3:
      this.downChess(nowPoint, islandConst.EMPTY);
      this.options.onError({
        code: -3,
        message: '打劫，要隔一步才能落子',
      });
      break;
    case -4:
      this.downChess(nowPoint, islandConst.EMPTY);
      this.options.onError({
        code: -4,
        message: '不允许自杀',
      });
      break;
    default:
      console.error(`落子未知状态:${status}`);
    }
  };

  // 自动下一步(0.5-3s之后自动下一步)
  autoPlay = () => {
    const { etWant } = this.options;
    if (this.gameEnd) {
      return false;
    }
    this.noCanChess = true;
    const timer = Math.max(Math.random() * 3, 0.5) * 1000;
    if (etWant) {
      etWant('wanting');
    }
    setTimeout(() => {
      const pt = this.WGLogic.getNext();
      if (etWant) {
        etWant('wanted');
      }
      if (pt) {
        this.static.chessAudio.play();
        this.downChess(pt, this.Et.btColor);
        this.noCanChess = false;
      }
    }, timer);
  };

  downChess = (pt, setColor, alpha = 1) => {
    const color = isNumber(setColor) ? setColor : this.WGLogic.getCurrentColor();
    const sprite = this.chess[pt.x][pt.y];
    if (color === islandConst.BLACK) {
      this.drawBackChess(sprite, sprite.x, sprite.y, alpha);
    } else if (color === islandConst.WHITE) {
      this.drawWhiteChess(sprite, sprite.x, sprite.y, alpha);
    } else if (color === islandConst.EMPTY) {
      this.drawTransparentChess(sprite, sprite.x, sprite.y);
    }
    this.stage.update();
  };

  onKillStone = (black_killed, white_killed, block) => {
    this.options.onKillStone(black_killed, white_killed);
    this.static.tzAudio.play();
    block.forEach((pt) => {
      const sprite = this.chess[pt.x][pt.y];
      this.drawTransparentChess(sprite, sprite.x, sprite.y);
    });
    this.stage.update();
  };

  /*
  * 判断胜负触发函数
  * @param isWin true代表人赢，false代表机器赢, 'flat'代表平局
  * @param stones 吃子数量
  * @param level  机器人级别
  */
  onResult = (isWin, stones, level) => {
    this.gameEnd = true;
    // 关闭棋子绑定事件
    this.offChessEvent();
    this.options.onSuccess(isWin, stones, level, this.WGLogic.getSgf());
  };

  // 关闭棋子事件
  offChessEvent = () => {
    this.chess.forEach((row) => {
      row.forEach((chess) => {
        chess.removeAllEventListeners();
      });
    });
  };
}
